import React from 'react';

import i18next from 'i18next';

import DisplayNumber from '@commons/DisplayNumber';
import Text from '@commons/Text';

import { CustomHyperLink } from './styledComponents';

export const getColumns = (isProductChild) => [
  {
    id: 'name',
    name: i18next.t(
      isProductChild
        ? 'ADMIN.PRODUCTS.SIMPLE_MODIFIER_CASHIER_PRODUCTS_FIRST_COLUMN_NAME_FOR_CHILD_PRODUCT'
        : 'ADMIN.PRODUCTS.SIMPLE_MODIFIER_CASHIER_PRODUCTS_FIRST_COLUMN_NAME_FOR_PARENT_PRODUCT',
    ),
    type: 'string',
    propertyKey: 'name',
    tooltipText: i18next.t(
      isProductChild
        ? 'ADMIN.PRODUCTS.SIMPLE_MODIFIER_CASHIER_PRODUCTS_FIRST_COLUMN_FOR_CHILD_PRODUCT_TOOLTIP'
        : 'ADMIN.PRODUCTS.SIMPLE_MODIFIER_CASHIER_PRODUCTS_FIRST_COLUMN_FOR_PARENT_PRODUCT_TOOLTIP',
    ),
  },
  {
    id: 'inpulseProduct',
    name: 'Produit Inpulse',
    type: 'string',
    propertyKey: 'productName',
    render: (productName, { associatedProduct }) => (
      <CustomHyperLink
        href={`/admin/products/${associatedProduct?.id}/details`}
        rel="noreferrer"
        target="_blank"
      >
        {productName}
      </CustomHyperLink>
    ),
  },
  {
    id: 'priceWithTaxes',
    displayName: i18next.t('ADMIN.PRODUCTS.CASHIER_PRODUCTS_ASSOCIATION_PRICE'),
    name: i18next.t('ADMIN.PRODUCTS.CASHIER_PRODUCTS_ASSOCIATION_PRICE'),
    propertyKey: 'priceWithTaxes',
    filterType: 'numeric',
    render: (priceWithTaxes) => (
      <DisplayNumber displayCurrencyCode={true} number={priceWithTaxes} />
    ),
  },
  {
    id: 'vatRate',
    displayName: i18next.t('ADMIN.PRODUCTS.CASHIER_PRODUCTS_ASSOCIATION_VAT'),
    name: i18next.t('ADMIN.PRODUCTS.CASHIER_PRODUCTS_ASSOCIATION_VAT'),
    propertyKey: 'vatRate',
    filterType: 'numeric',
    render: (vatRate) => <Text>{vatRate}%</Text>,
  },
];
